// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            dataNote: [
                {
                    label: 'Some things to note when remove machine',
                    children: [
                        {
                            label: '• Be cautious every time you delete the machine and make sure you have either retrieved all important data in the image or copied them to the Z drive.',
                        },
                        {
                            label: '• This action will permanently delete your machine and cannot be restored in any way.',
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.REMOVE_IMAGE);
        },

        //#region Remove image 
        remove() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.REMOVE_IMAGE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess('Remove success !', `Image <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> has been remove successfully</span>`);
                        this.$store.dispatch("auth/basicUserInformationView");
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Boot failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}